export default __webpack_public_path__ + "static/media/message-circle-dark.648b6cc2.svg";